import { ModerationModelConfigs } from './tenantConfigTypes';

export const TENANT = 'tenant';

export const IS_MODERATION_BY_ARTICLES_ENABLED = 'tenant.host_panel.isModerationByArticlesEnabled';
export const RESTRICTED_GROUPS_ENABLED = 'tenant.moderation.restricted_words_ui_v2_enabled';
export const TABS_V2_API_ENABLED = 'tenant.moderation.tabs_v2_api_enabled';
export const SAFEST_ENABLED = 'tenant.moderation.is_safest_enabled';
export const BULK_ACTIONS_ENABLED = 'tenant.admin-panel.bulk_actions_enabled';
export const RESTRICTED_GROUPS_EXCEPTIONS_ENABLED =
  'tenant.moderation.restricted_groups_exceptions_enabled';
export const MODERATION_MODELS_CONFIG = 'tenant.moderation.models_config';

export const moderationModeratorConfigMap = {
  [IS_MODERATION_BY_ARTICLES_ENABLED]: false,
  [RESTRICTED_GROUPS_ENABLED]: false,
  [TABS_V2_API_ENABLED]: false,
  [SAFEST_ENABLED]: false,
  [BULK_ACTIONS_ENABLED]: false,
  [RESTRICTED_GROUPS_EXCEPTIONS_ENABLED]: false,
  [MODERATION_MODELS_CONFIG]: {} as ModerationModelConfigs
};

const DEFAULT_ADS_TEXT_CONFIG = {
  url: 'https://spotim-prd-static-assets.s3.amazonaws.com/production/publishers/publishers-v3.txt',
  updateDate: 'July 22nd 2020',
  sellerIdOverrides: []
};

const DEFAULT_APP_ADS_TEXT_CONFIG = {
  url:
    'https://spotim-prd-static-assets.s3.amazonaws.com/production/publishers/publishers-v1-app.txt',
  updateDate: 'December 15th 2022',
  sellerIdOverrides: []
};

export const ADS_TEXT = 'tenant.ads.adsTxt';
export const APP_ADS_TEXT = 'tenant.ads.appAdsTxt';

export const settingsGeneralConfigMap = {
  [ADS_TEXT]: DEFAULT_ADS_TEXT_CONFIG,
  [APP_ADS_TEXT]: DEFAULT_APP_ADS_TEXT_CONFIG
};
